"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacify = exports.lighten = exports.getRgbColorFromTheme = exports.getHexColorFromTheme = exports.darken = void 0;
var _stencilReactThemeDefault = _interopRequireDefault(require("@amzn/stencil-react-theme-default"));
/**
 * Gets RGB parts from a color
 * @param color{string}
 * @returns {r: number, g: number, b: number}
 */
const parseColor = color => {
  if (color.match(/^rgb/)) {
    const result = color.replace(/[a-z]|\(|\)|\s/g, '').split(',').map(colorPart => parseInt(colorPart));
    return {
      r: result[0],
      g: result[1],
      b: result[2]
    };
  }
  const fullHex = color.length < 6 ? color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b) : color;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
  const getColorPart = index => result ? parseInt(result[index], 16) : 255;
  return {
    r: getColorPart(1),
    g: getColorPart(2),
    b: getColorPart(3)
  };
};

/**
 * @param color{string}
 * @returns {string} `rgb(R, G, B)`
 */
const getRgbColor = color => {
  const {
    r,
    g,
    b
  } = parseColor(color);
  return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};

/**
 * Adds opacity to rgba return
 * @param color {string}
 * @param amount {number}
 * @returns {string} `rgba(R, G, B, opacity)`
 */
const opacify = (color, amount) => {
  if (amount < 0) {
    return opacify(color, 0);
  }
  if (amount >= 1) {
    return getRgbColor(color);
  }
  const {
    r,
    g,
    b
  } = parseColor(color);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(amount, ")");
};

/**
 * Adjusts color to a darker shade and returns rgb string
 * @param color {string}
 * @param amount {number}
 * @returns {string} `rgb(R, G, B)`
 */
exports.opacify = opacify;
const darken = (color, amount) => {
  if (amount === 0) {
    return getRgbColor(color);
  }
  const {
    r,
    g,
    b
  } = parseColor(color);
  const percent = Math.max(0, 1 - amount);
  const darkenPart = colorPart => {
    const result = Math.round(colorPart * percent);
    return result < 255 ? result : '255';
  };
  return "rgb(".concat(darkenPart(r), ", ").concat(darkenPart(g), ", ").concat(darkenPart(b), ")");
};

/**
 * Adjusts color to a lighter shade and returns rgb string
 * @param color {string}
 * @param amount {number}
 * @returns {string} `rgb(R, G, B)`
 */
exports.darken = darken;
const lighten = (color, amount) => {
  if (amount === 0) {
    return getRgbColor(color);
  }
  const {
    r,
    g,
    b
  } = parseColor(color);
  const percent = Math.min(1, amount);
  const lightenPart = colorPart => {
    const result = Math.round(colorPart + (255 - colorPart) * percent);
    return result < 255 ? result : '255';
  };
  return "rgb(".concat(lightenPart(r), ", ").concat(lightenPart(g), ", ").concat(lightenPart(b), ")");
};

/**
 * Gets a color value from default Stencil theme
 * @param color {keyof StencilThemeColors}
 * @returns {string}
 */
exports.lighten = lighten;
const getHexColorFromTheme = color => _stencilReactThemeDefault.default.color[color];

/**
 * Gets a color value from default Stencil theme and return is as rgb string
 * @param color {keyof StencilThemeColors}
 * @returns {string} `rgb(R, G, B)`
 */
exports.getHexColorFromTheme = getHexColorFromTheme;
const getRgbColorFromTheme = color => getRgbColor(_stencilReactThemeDefault.default.color[color]);
exports.getRgbColorFromTheme = getRgbColorFromTheme;